import React from 'react';

export default function Hero() {
  return (
    <section>
      <div className='xcontainer'>
        <div className="hero h-96 md:h-[350px] rounded-none overflow-hidden" style={{ backgroundImage: `url("/bg.jpg")` }}>
          <div className="hero-overlay "></div>
          {/* // bg-opacity-60 bg-secondary */}
          <div className="hero-content text-center text-secondary-content">
            <div className="max-w-lg">
              <h1 className="mb-5 sm:mb-7 text-4xl sm:text-5xl font-bold">
              开源 AI 算力云租赁系统
              </h1>
              <p className="mb-5 sm:mb-7 sm:text-lg">
                我们为您提供GPU云管理软件，解决企业AI算力管理，让您的企业部署云更快捷简单，业务在AI帮助下，高效精准，如虎添翼<br /><br />
                <b>高校，科研机构可以下载<span className='text-warning'>终身免费</span>使用，请联系作者获取授权</b>
              </p>
              
              <a href="https://gpu.flopscloud.cn" className="btn btn-warning sm:btn-wide">立刻使用</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}